import { useEffect, useState } from 'react';

import {
  CompanyStorageDisposition,
  fetchPresignedCompanyStorageUrl,
  isStoredS3ObjectUrl,
} from '../utils/company-storage-url.util';

export const useCompanyStorageDisplayUrl = (
  companyId: string | undefined,
  storageUrl: null | string | undefined,
) => {
  const [displayUrl, setDisplayUrl] = useState<string | undefined>(() => {
    if (!storageUrl) return undefined;
    if (!isStoredS3ObjectUrl(storageUrl)) return storageUrl;
    return undefined;
  });

  useEffect(() => {
    if (!storageUrl) {
      setDisplayUrl(undefined);
      return;
    }

    if (!isStoredS3ObjectUrl(storageUrl)) {
      setDisplayUrl(storageUrl);
      return;
    }

    if (!companyId) {
      setDisplayUrl(undefined);
      return;
    }

    let cancelled = false;
    void (async () => {
      try {
        const url = await fetchPresignedCompanyStorageUrl(
          companyId,
          storageUrl,
          CompanyStorageDisposition.INLINE,
        );
        if (!cancelled) setDisplayUrl(url);
      } catch {
        if (!cancelled) setDisplayUrl(undefined);
      }
    })();

    const interval = window.setInterval(
      () => {
        void (async () => {
          try {
            const url = await fetchPresignedCompanyStorageUrl(
              companyId,
              storageUrl,
              CompanyStorageDisposition.INLINE,
            );
            if (!cancelled) setDisplayUrl(url);
          } catch {}
        })();
      },
      4 * 60 * 1000,
    );

    return () => {
      cancelled = true;
      window.clearInterval(interval);
    };
  }, [companyId, storageUrl]);

  return displayUrl;
};
